import { ArrowDown, ArrowUp } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import Sorting from 'common/components/icons/Sorting';
import { SortBy, SortByState, SortingOrder } from 'modules/shared-menu/hooks/useSelectionList';

type SelectionListSortingIconProps = {
  columnName: SortBy;
  appliedSortBy: SortByState;
};

const SortingIcon = styled(Sorting)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  cursor: pointer;
`;

const ArrowDownIcon = styled(ArrowDown)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  cursor: pointer;
`;

const ArrowUpIcon = styled(ArrowUp)`
  fill: ${cbSemanticCssVars.textSecondary};
  width: 12px;
  cursor: pointer;
`;

const sortingIconMap: Record<SortingOrder | 'DEFAULT', JSX.Element> = {
  ASC: <ArrowUpIcon />,
  DESC: <ArrowDownIcon />,
  DEFAULT: <SortingIcon />,
};

export const SelectionListSortingIcon = ({ columnName, appliedSortBy }: SelectionListSortingIconProps) => (
  <div>{sortingIconMap[appliedSortBy?.[columnName] ?? 'DEFAULT']}</div>
);
